export const AxiomThemeZIndexes = {
  appScreenBlocker: 5000,
  mobileCtaFooter: 5,
};
